module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"./src/assets/images/inCred-fin.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"fbfa2d46ff4e31f565932f0aca4be9f6"},
    },{
      plugin: require('../node_modules/gatsby-plugin-react-helmet-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://www.incred.com","noQueryString":true,"noHash":true,"exclude":["/business-loans/swiggy/swiggy-auto/[...]/","/business-loans/amazon-seller/[...]/","/business-loans/amazon-rbf/[...]/","/business-loans/shiprocker-pre-approved/[...]/","/business-loans/swiggy/swiggy-auto/%5B...%5D/","/business-loans/amazon-seller/%5B...%5D/","/business-loans/amazon-rbf/%5B...%5D/","/business-loans/shiprocker-pre-approved/%5B...%5D/"]},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
